import type { NopPaymentMethodModel } from '~/repository/modules/payment.module';
import type { KlarnaPaymentMethodModel } from './KlarnaSession.api.model';

export const SWISH_METHOD = 'Payments.Electra.Swish';
export const TELIAPAY_METHOD = 'Payments.Electra.TeliaPay';
export const CARD_PAYMENT_METHOD = 'Payments.Electra.Netaxept.CardPayment';
export const CASH_ON_DELIVERY = 'Payments.Electra.CashOnDelivery';
export const KLARNA_METHOD = 'Payments.Electra.Klarna';
export const KLARNA_PAY_NOW_IDENTIFIER = `${KLARNA_METHOD},pay_now`;
export const KLARNA_PAY_LATER_IDENTIFIER = `${KLARNA_METHOD},pay_later`;
export const KLARNA_PARTPAYMENT_IDENTIFIER = `${KLARNA_METHOD},pay_over_time`;
export const ELECTRAFINANS_METHOD = 'Payments.Electra.ElectraFinans';
export const INVOICE_PAYMENT_METHOD = 'pay-by-invoice';

export const PAYMENT_METHODS_THAT_ARE_MONTHLY_PAYMENT = [
  TELIAPAY_METHOD,
  ELECTRAFINANS_METHOD,
  KLARNA_PARTPAYMENT_IDENTIFIER,
];

export type PaymentMethod = {
  commaSeparatedSystemNameAndIdentifier: string;
  name: string;
  systemName: string;
  description?: string;
  logoUrl?: string;
  klarnaPaymentMethodCategoryIdentifier?: string;
};

export const mapNopPaymentMethodToPaymentMethod = (
  electraMethod: NopPaymentMethodModel,
): PaymentMethod => {
  return {
    commaSeparatedSystemNameAndIdentifier:
      electraMethod.payment_method_system_name,
    name: electraMethod.name,
    systemName: electraMethod.payment_method_system_name,
    description: electraMethod.description,
    logoUrl: electraMethod.logo_url,
  };
};

export const mapKlarnaPaymentMethodToPaymentMethod = (
  klarnaMethod: KlarnaPaymentMethodModel,
): PaymentMethod => {
  const KlarnaNopPaymentMethodSystemName = 'Payments.Electra.Klarna';

  return {
    commaSeparatedSystemNameAndIdentifier: `${KlarnaNopPaymentMethodSystemName},${klarnaMethod.Identifier}`,
    name: `Klarna ${klarnaMethod.Name}`,
    systemName: KlarnaNopPaymentMethodSystemName,
    description: '',
    logoUrl: klarnaMethod.AssetUrls.Standard,
    klarnaPaymentMethodCategoryIdentifier: klarnaMethod.Identifier,
  };
};
